// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#720d5d"};